import React, { useState, useEffect, useCallback } from "react";
import Navbar from "../../components/Navbar/Navbar";
import { ConfigProvider, Breadcrumb, DatePicker, Button, Select } from "antd";
import arEG from "antd/es/locale/ar_EG";
import { DoubleRightOutlined, DownloadOutlined } from "@ant-design/icons";
import ShimmerLoader from "../../loading";
import "../../styles.css";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import { routes } from "../../Routes";
import LoadingSpinner from "../../components/Loading";
import { getVendorDetails } from "../../API  Functions/PurchaseFunctions";
import axiosInstance from "../../AxiosInstance";
import AddPackage from "../../assets/Inventory/AddPackage.svg";
import { URLS } from "../../API/API endpoints";
import SearchBox from "../CustomWidgets/SearchBox";
import SelectBox from "../CustomWidgets/SelectBox";
import moment from "moment";
import { getStoreUsers } from "../../API  Functions/UserMangement";
import ExpenseManagementTable from "./ExpenseManagementTable";
import AddNewExpense from "./AddNewExpense";
import dayjs from "dayjs";
import { toast } from "react-toastify";
import DateFilter from "../ui/DateFilter";
import PaymentTiles from "./ExpenseComponents/paymentTiles";
import { checkPermission } from "../../Utils/permissionHelper";

const ExpenseManagement = () => {
  const { t, i18n } = useTranslation();
  const company_id = useSelector(
    (state) => state?.login?.user?.result?.company_id
  );
  const isGinne = useSelector(
    (state) => state?.geneLoginReducer?.isGinneLogin
  );

  const user_id = useSelector((state) => state?.login?.user?.result?.user_id);
  const { Option } = Select;
  const [loading, setLoading] = useState(false);
  const [expencesData, setExpencesData] = useState([]);
  const [currentLimit, setCurrentLimit] = useState(10); // Default limit
  const [currentOffset, setCurrentOffset] = useState(0); // Default offset
  const [selectedRange, setSelectedRange] = useState("thisMonth");
  const today = dayjs();
  const formatToday = today.format("YYYY-MM-DD");
  const startofMonth = today.startOf("month").format("YYYY-MM-DD");
  const [startDate, setStartDate] = useState(startofMonth);
  const [endDate, setEndDate] = useState(formatToday);
  const [selectedUser, setSelectedUser] = useState(null);
  const [userData, setUserData] = useState([]);
  const [totalAmount, setTotalAmount] = useState();
  const [transactionModal, setOpenTransactionModal] = useState(false);
  const [pageIndex, setPageIndex] = useState(1);
  const [paymentBalances, setPaymentBalances] = useState([]);
  const [bankAccounts, setBankAccounts] = useState([]);
  const [selectedPaymentMethod, setSelectedPaymentMethod] = useState([]);

  console.log("selectedPaymentMethod", selectedPaymentMethod);

  const allStores = useSelector(
    (state) => state?.storeReducer?.selectedStore?.is_select_all_store
  )


  const debounce = (func, delay) => {
    let timer;
    return function (...args) {
      const context = this;
      clearTimeout(timer);
      timer = setTimeout(() => func.apply(context, args), delay);
    };
  };

  useEffect(() => {
    GetUserData();
  }, []);

  useEffect(() => {
    getTransactionLogs(selectedUser, currentOffset, currentLimit, startDate, endDate, selectedPaymentMethod);
  }, [currentLimit, currentOffset]);

  const GetUserData = async () => {
    try {
      const res1 = await getStoreUsers(user_id);

      if (res1?.result[0]?.status_code === 200) {
        const activeUsers = res1.result[0]?.response?.filter(
          (user) => user.active === true
        );
        setUserData(activeUsers);
      } else {
        setUserData([]);
      }
    } catch (error) {
      console.error("Error fetching KPI data:", error);
    }
  };

  const getTransactionLogs = async (
    selectedValue,
    offset,
    limit,
    start_date,
    end_date,
    payment_method
  ) => {
    // setLoading(true);
    try {
      const response = await axiosInstance.post(URLS.TRANSACTIONS_LOGS, {
        ...(selectedValue != null && { user_id: selectedValue }),
        company_id: company_id,
        start_date: start_date || startofMonth,
        end_date: end_date || formatToday,
        limit: limit,
        offset: offset,
        lang: i18n.language === "ar" ? "ar_001" : "en_US",
        is_expense: false,
        ...(payment_method && { payment_method })
      });
      if (response.data?.result?.status == "success") {
        setTotalAmount(response.data?.result?.total_amount);
        setExpencesData(response.data?.result?.transactions);
        setPaymentBalances(response.data?.result?.payment_balances || []);
        setBankAccounts(response?.data?.result?.bank_accounts || [])
        setLoading(false);

      } else {
        setTotalAmount("0");
        setExpencesData([]);
        setPaymentBalances([]);
      }
    } catch (error) {
      console.error("Error fetching KPI data:", error);
    } finally {
      setLoading(false);
    }
  };


  const handleOptionChange = (selectedValue) => {
    setLoading(true);
    setSelectedPaymentMethod(null)
    // setPageIndex(1); // Reset pagination to page 1

    // setCurrentOffset(0); // Reset to first page on filter change

    if (selectedValue === "All Users") {
      setSelectedUser(null); // Reset selected category
      getTransactionLogs(null, 0, 10, startDate, endDate, selectedPaymentMethod);
    } else {
      setSelectedUser(selectedValue);
      if (selectedValue) {
        getTransactionLogs(selectedValue, 0, 10, startDate, endDate, selectedPaymentMethod);
      }
    }
  };

  const runApi = (values) => {
    console.log("paginfnation====>", values);
    getTransactionLogs(
      selectedUser,
      values.offset,
      values.limit,
      startDate,
      endDate,
      selectedPaymentMethod
    );
  };

  const handleTileClick = (paymentMethod) => {
    // setCurrentLimit(10);
    // setCurrentOffset(0);
    // setCurrentLimit(10);       // ✅ Reset to first page
    // setCurrentOffset(0);
    setLoading(true)
    setSelectedPaymentMethod(paymentMethod); // Set selected payment method
    getTransactionLogs(
      selectedUser,
      0,
      10,
      startDate,
      endDate,
      paymentMethod // Pass paymentMethod as argument to getTransactionLogs
    );
  };

  const handleExport = async () => {
    let payload = {
      company_id: company_id,
      lang: i18n.language === "ar" ? "ar_001" : "en_US",
    };
    const response = await axiosInstance.post(
      URLS.CASHBOX_LEDGER_EXCEL,
      payload
    );
    if (response?.data?.result?.status === "success") {
      downloadFile(response?.data?.result?.file);
    } else {
      toast.error(response?.data?.result.status);
    }
  };

  const downloadFile = (base64Data) => {
    try {
      if (
        !base64Data ||
        typeof base64Data !== "string" ||
        base64Data.trim() === ""
      ) {
        alert("No valid file data available for download");
        return;
      }

      let cleanBase64 = base64Data
        .trim()
        .replace(/^data:[\w/+-]+;base64,/, "")
        .replace(/^["']|["']$/g, "")
        .replace(/\s/g, "");

      const padLength = 4 - (cleanBase64.length % 4);
      if (padLength < 4) cleanBase64 += "=".repeat(padLength);

      let binaryString = atob(cleanBase64);
      const bytes = new Uint8Array(binaryString.length);
      for (let i = 0; i < binaryString.length; i++) {
        bytes[i] = binaryString.charCodeAt(i);
      }

      const header = new Uint8Array(bytes.buffer, 0, 8);
      let mimeType = "application/octet-stream";
      let fileExtension = "bin";

      if (header[0] === 0x50 && header[1] === 0x4b) {
        mimeType =
          "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";
        fileExtension = "xlsx";
      } else if (
        header[0] === 0xd0 &&
        header[1] === 0xcf &&
        header[2] === 0x11 &&
        header[3] === 0xe0
      ) {
        mimeType = "application/vnd.ms-excel";
        fileExtension = "xls";
      } else if (new TextDecoder().decode(header).includes(",")) {
        mimeType = "text/csv";
        fileExtension = "csv";
      }

      const blob = new Blob([bytes], { type: mimeType });
      const timestamp = moment().format("YYYY-MM-DD_HH.mm.ss"); // Using period for time
      const filename = `${t("cashbox_ledger")}_${timestamp}.${fileExtension}`;
      const url = URL.createObjectURL(blob);

      const link = document.createElement("a");
      link.href = url;
      link.download = filename;
      document.body.appendChild(link);
      link.click();
      setTimeout(() => {
        document.body.removeChild(link);
        URL.revokeObjectURL(url);
      }, 100);
    } catch (error) {
      console.error("File download failed:", error);
      alert(`Download failed: ${error.message || "Unknown error"}`);
    }
  };

  return (
    <>
      {loading && <LoadingSpinner />}
      <div className="flex w-full flex-col overflow-y-auto bg-[#F6F7F9] pb-2 md:h-full">
        <Navbar heading="Cashbox Ledger" />
        <div className="flex-grow overflow-y-auto custom-scrollbar overflow-hidden bg-[#F6F7F9]">
          <>
            {/* <div className="font-extrabold ps-3">
              <Breadcrumb
                separator={<DoubleRightOutlined />}
                items={[
                  {
                    title: <span>{t("settings")}</span>,
                    key: "settings",
                  },
                  { title: t("Cashbox Ledger") },
                ]}
                className="relative mt-3 font-semibold"
              />
            </div> */}
            <div className="ms-1 rounded-lg bg-[#F6F7F9] sm:ms-3">

              {/* 🔹 Row 1: Filters + Total Amount */}
              <div className="flex flex-col gap-3 p-2 sm:p-4 md:flex-row md:items-center md:justify-between">
                {/* Filters on left */}
                <div className="flex w-full flex-col gap-2 sm:flex-row sm:items-center md:w-auto md:gap-3">
                  <Select
                    className="w-full overflow-hidden sm:w-auto"
                    style={{ width: "100%", maxWidth: 220, minWidth: 200, height: 40 }}
                    placeholder={t("Select User")}
                    value={selectedUser || "All Users"}
                    onChange={handleOptionChange}
                  >
                    <Option value="All Users">{t("All Users")}</Option>
                    {Object.values(userData)?.map((option) => {
                      const { user_id, name, phone, email } = option;
                      let displayText = name;
                      if (phone) displayText += ` (${phone})`;
                      else if (email) displayText += ` (${email})`;

                      return (
                        <Option key={user_id} value={user_id}>
                          {displayText}
                        </Option>
                      );
                    })}
                  </Select>

                  <div className="mt-0 w-full sm:w-auto sm:mt-[-8px]">
                    <DateFilter
                      setSelectedRange={setSelectedRange}
                      selectedRange={selectedRange}
                      SubmitFilter={(start, date) => {
                        setStartDate(start);
                        setEndDate(date);
                        getTransactionLogs(selectedUser, 0, 10, start, date, selectedPaymentMethod);
                      }}
                    />
                  </div>

                </div>

                {/* Total Amount on right */}
                <div className="flex min-w-[180px] flex-col rounded-md bg-[#FFEDB1] px-4 py-3 text-gray-800 sm:px-6">
                  <span className="text-sm font-medium">{t("Total Amount")}</span>
                  <span className="text-xl font-bold">
                    EGP {totalAmount?.toFixed(2) || "--"}
                  </span>
                </div>
              </div>

              {/* 🔹 Row 2: Payment Method Tiles + Export Button */}
              <div className="mt-2 flex flex-col gap-3 px-2 sm:px-4 md:flex-row md:items-start md:justify-between">
                {/* Left side: Payment Tiles or empty space */}
                {paymentBalances?.length > 0 ? (
                  <div className="md:z-50 w-full overflow-hidden md:me-8 md:flex-1">
                    <h1> {t("Payment Methods")}</h1>
                    <PaymentTiles
                      paymentBalances={paymentBalances}
                      setSelectedPaymentMethod={handleTileClick}
                      selectedPaymentMethod={selectedPaymentMethod}
                      bankAccounts={bankAccounts}
                    />
                  </div>
                ) : (
                  <div className="hidden flex-1 md:me-8 md:block" /> // Empty div to maintain spacing
                )}

                {/* Right side: Export button and clear filter */}
                <div className="flex w-full flex-row md:flex-col items-start justify-between md:w-1/5 md:items-end">
                  <button
                    className="flex h-10 w-2/3 md:w-full items-center justify-center gap-2 rounded-lg bg-primaryBlue text-sm font-semibold text-white sm:w-48"
                    // onClick={() => handleExport()}
                    // onClick={() => {
                    //   if (checkPermission("/settings/cashboxledger", isGinne)) {
                    //     handleExport();
                    //   }
                    // }}
                    onClick={() => {
                      if (allStores) {
                        // If allStores is true, directly call handleExport
                        handleExport();
                      } else {
                        // Otherwise, check permission before calling handleExport
                        if (checkPermission("/settings/cashboxledger", isGinne)) {
                          handleExport();
                        }
                      }
                    }}
                  >
                    <DownloadOutlined style={{ fontSize: "1.5em", MozMarginStart: -10 }} />
                    <span>{t("Download in Excel")}</span>
                  </button>

                  <span
                    onClick={() => {
                      setSelectedRange("thisMonth");
                      setSelectedUser(null);
                      setSelectedPaymentMethod(null)
                      setLoading(true)
                      getTransactionLogs(null, 0, 10, null, null, null);
                    }}
                    className="me-0 mt-3 cursor-pointer text-sm font-semibold text-primaryBlue sm:me-4 md:mt-9"
                  >
                    {t("Clear Filter")}
                  </span>
                </div>
              </div>
            </div>
            {loading ? (
              <>
                <ShimmerLoader />
              </>
            ) : (

              <div className="ms-1 sm:ms-3 md:ms-6">
                <ExpenseManagementTable
                  additionalData={expencesData}
                  pagination={(values) => {
                    console.log("PAGONGAOKFSFIJ");
                    setCurrentLimit(values.limit);
                    setCurrentOffset(values.offset);
                    // runApi(values);
                  }}
                />
              </div>
            )}
            {/* </>
            )} */}
          </>
        </div>
        {transactionModal && (
          <AddNewExpense
            isOpen={transactionModal}
            onClose={() => setOpenTransactionModal(false)}
            userData={userData}
            ExpenseUpdated={() => {
              setOpenTransactionModal(false);
              getTransactionLogs(null, 0, 10);
            }}
          />
        )}
      </div>
    </>
  );
};

export default ExpenseManagement;
